import { useNavigate } from 'react-router';
import ArrowLeftImage from '../../../assets/icons/arrow_left.png';
import lobbyBattleButton from '../../../assets/cat-running/ui/button-battle.png';
import lobbyHeroBackground from '../../../assets/cat-running/ui/lobby-hero-bg.png';
import lobbyTitle from '../../../assets/cat-running/ui/lobby-title.png';
import lobbySingleButton from '../../../assets/cat-running/ui/button-single.png';
import rankingIcon from '../../../assets/cat-running/ui/icon-ranking.png';
import skinIcon from '../../../assets/cat-running/ui/icon-skinshop.png';
import CatRunningOutlineFrame from './CatRunningOutlineFrame';

const QUICK_ACTIONS = [
  { key: 'skinshop', label: '스킨샵', icon: skinIcon },
  { key: 'ranking', label: '랭킹', icon: rankingIcon }];

const formatHistoryMode = (mode) => (mode === 'SINGLE' ? '싱글모드' : mode === 'BATTLE' ? '배틀모드' : mode || '플레이');

const formatHistoryDate = (createdAt) => {
  if (!createdAt) return '';
  const parsed = new Date(String(createdAt).replace(' ', 'T'));
  if (Number.isNaN(parsed.getTime())) return createdAt;

  return `${String(parsed.getMonth() + 1).padStart(2, '0')}/${String(parsed.getDate()).padStart(2, '0')} ${String(parsed.getHours()).padStart(2, '0')}:${String(parsed.getMinutes()).padStart(2, '0')}`;
};

export default function CatRunningLobbyScreen({
  onStart,
  onBattle,
  onReplayTest,
  onRanking,
  snackCount,
  playHistory = [],
}) {
  const navigate = useNavigate();
  const highestPlayedDistanceM = playHistory.reduce(
    (highestDistance, history) => Math.max(highestDistance, Number(history.distanceM ?? 0)),
    0,
  );

  const handleQuickAction = (action) => {
    if (action.key === 'ranking') {
      onRanking?.();
      return;
    }

    window.alert(`${action.label} 기능은 준비 중입니다.`);
  };

  return (
    <div className="min-h-screen bg-[#0F0B0B]">
      <div className="mx-auto flex min-h-screen w-full max-w-[500px] justify-center">
        <div className="relative min-h-screen w-full overflow-hidden bg-[#111111] pb-[118px]">
          <div className="relative aspect-[360/420] overflow-hidden">
            <img src={lobbyHeroBackground} alt="캣러닝 배경" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#111111]" />

            <div className="absolute inset-x-0 top-0 flex h-11 items-center px-3">
              <button
                type="button"
                className="flex h-6 w-6 items-center justify-center border-0 bg-transparent p-0"
                onClick={() => navigate('/playground')}
                aria-label="뒤로가기"
              >
                <img src={ArrowLeftImage} alt="" className="h-6 w-6 object-contain brightness-0 invert" />
              </button>
            </div>

            <div className="absolute inset-x-0 top-[85px] flex flex-col items-center">
              <img src={lobbyTitle} alt="CAT RUNNING" className="h-auto w-[211px]" />
              <CatRunningOutlineFrame
                className="mt-[17px] h-[33px] w-[182px]"
                contentClassName="flex items-center justify-center"
                fillClassName="bg-black/25"
                contentAbsolute={true}
              >
                <p className="m-0 font-['Pretendard'] text-[12px] font-bold leading-none text-white">
                  한계 돌파 러닝, 쏟아지는 보상!
                </p>
              </CatRunningOutlineFrame>
            </div>
          </div>

          <div className="relative z-10 -mt-[110px] px-[7px]">
            <div className="rounded-[24px] px-0 pb-7 pt-7 shadow-[0_24px_48px_rgba(0,0,0,0.45)] backdrop-blur-[1px]">
              <div className="px-0">
                <button
                  type="button"
                  className="relative mt-6 block h-11 w-full border-0 bg-transparent p-0"
                  onClick={onStart}
                  aria-label="싱글모드"
                >
                  <img src={lobbySingleButton} alt="" className="absolute inset-0 h-full w-full object-fill" />
                  <span className="absolute inset-0 flex items-center justify-center font-['DungGeunMo'] text-[20px] tracking-[-0.03em] text-black">
                    싱글모드
                  </span>
                </button>
                {/* <button
                  type="button"
                  className="relative block h-11 w-full border-0 bg-transparent p-0 mt-3"
                  onClick={onBattle}
                  aria-label="배틀모드"
                >
                  <img src={lobbyBattleButton} alt="" className="absolute inset-0 h-full w-full object-fill" />
                  <span className="absolute inset-0 flex items-center justify-center font-['DungGeunMo'] text-[20px] tracking-[-0.03em] text-black">
                    배틀모드
                  </span>
                </button> */}
                {/* <button
                  type="button"
                  className="mt-3 flex h-11 w-full items-center justify-center rounded-[10px] border border-[#B9D8E8] bg-[#EAF7FF] font-['Pretendard'] text-[15px] font-bold text-[#204357]"
                  onClick={onReplayTest}
                >
                  리플레이 테스트
                </button> */}
              </div>

              <div
                className="mx-2 mt-5 h-[1px] w-auto shadow-[0_0_10px_rgba(255,255,255,0.95)]"
                style={{
                  background: 'linear-gradient(90deg, #000000 0%, #AAAAAA 50%, #000000 100%)',
                }}
              />

              <div className="mx-2 mt-7">
                <div className={`grid gap-3 ${QUICK_ACTIONS.length === 1 ? 'grid-cols-1' : 'grid-cols-2'}`}>
                  {QUICK_ACTIONS.map((action) => (
                    <button
                      key={action.key}
                      type="button"
                      disabled={action.key === 'skinshop'}
                      aria-disabled={action.key === 'skinshop'}
                      className={`flex h-[60px] w-full items-center justify-center gap-2 rounded-[8px] border-0 bg-white px-4 py-4 ${
                        action.key === 'skinshop' ? 'cursor-not-allowed opacity-45 grayscale' : ''
                      }`}
                      onClick={() => handleQuickAction(action)}
                    >
                      <img src={action.icon} alt="" className="h-8 w-8 object-contain" />
                      <span className="font-['Pretendard'] text-[18px] font-bold leading-none text-[#333333]">
                        {action.label}
                      </span>
                    </button>
                  ))}
                </div>

                <div className="mt-6 rounded-[8px] border border-[#E7D4A6] bg-white px-5 py-5">
                  <div className="flex items-center justify-center gap-[10px] font-['Pretendard'] text-base font-bold text-[#5E5E5E]">
                    <span>플레이 기록</span>
                    <span className="h-4 w-px bg-[#D8BE8A]" />
                    <span>
                      내 최고기록: <span className="text-[#D39A22]">{highestPlayedDistanceM.toLocaleString('ko-KR')}m</span>
                    </span>
                  </div>
                  {playHistory.length === 0 ? (
                    <p className="m-0 mt-5 text-center font-['Pretendard'] text-sm font-medium leading-none text-[#9A9A9A]">
                      아직 기록이 없습니다
                    </p>
                  ) : (
                    <div className="mt-4 divide-y divide-[#F0E8D8]">
                      {playHistory.map((history) => {
                        const distanceM = Number(history.distanceM ?? 0);
                        const isHighestDistance = distanceM === highestPlayedDistanceM;

                        return (
                          <div
                            key={history.historyNo ?? history.roundNo ?? `${history.createdAt}-${history.distanceM}`}
                            className="flex items-center justify-between gap-3 py-2 font-['Pretendard'] text-[13px] leading-none"
                          >
                            <span className="flex min-w-0 items-center gap-2">
                              <span className="inline-flex shrink-0 items-center rounded-full border-2 border-[#ccb774] bg-[#f9edcd] px-2 py-1 font-['DungGeunMo'] text-[14px] font-normal leading-none tracking-[0.08em] text-[#5B5B5B]">
                                {formatHistoryMode(history.mode)}
                              </span>
                              <span className={`truncate font-bold ${isHighestDistance ? 'text-[#D39A22]' : 'text-[#4E4E4E]'}`}>
                                {distanceM.toLocaleString('ko-KR')}m
                              </span>
                            </span>
                            <span className="shrink-0 font-medium text-[#9A9A9A]">{formatHistoryDate(history.createdAt)}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
